import React from "react";

import PointsTk from "~/components/pages/personal/cart/step1/deliveryMap/pointsTk";

import Points from "../points";
import styles from "./index.module.scss";

export default function Balloon({
  point,
  onSelectPoint,
  selectedPayment,
  pointId,
  isTk,
}: any) {
  return (
    <div className={styles.BalloonPoint}>
      {isTk ? (
        <PointsTk
          points={[point]}
          onSelectPoint={onSelectPoint}
          selectedPayment={selectedPayment}
          pointId={pointId}
          isBallon
        />
      ) : (
        <Points
          points={[point]}
          onSelectPoint={onSelectPoint}
          selectedPayment={selectedPayment}
          pointId={pointId}
          isBallon
        />
      )}
    </div>
  );
}
